/* @flow */

import * as React from 'react';
import styled from 'styled-components';

import FlexBox from '../../FlexBox';

const AvatarBox = styled(FlexBox).attrs(() => ({
  className: 'bnc-avatar',
}))`
  width: 38px;
  height: 38px;
  border-radius: 100%;
  border: 1px solid #f2f2f2;
  font-size: 20px;
  color: #fff;
  font-weight: 600;
  position: relative;
  > img {
    position: absolute;
    bottom: 2px;
    left: 50%;
    transform: translateX(-50%) rotate(0deg);
  }

  :hover img {
    transform: translateX(-50%) rotate(180deg);
  }

`;

type Props = {
  text: string,
  shouldArrow: boolean,
};

const UserAvatar = ({ text, shouldArrow }: Props) => (
  <AvatarBox justify="center" align="center">
    {text}
    {shouldArrow && <img src={require('./arrow.svg')} alt="arrow" />}
  </AvatarBox>
);

UserAvatar.defaultProps = {
  text: '',
  shouldArrow: false,
};
export default UserAvatar;
